import { Button, Card, Group, Text, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useState } from "react";
import { HiArrowRight, HiLocationMarker } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import Globe from "../albums/sections/Globe";
import AppCard from "../common/AppCard";
import GlobeLocationsShowcase from "../albums/sections/GlobeLocationsShowcase";
import useGlobalState, { globalSettings } from "src/globalState";
import { Settings } from "src/settings";

export default function GlobeCard(props: { cardClassName?: string }) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const navigate = useNavigate();
  const [settings, setSettings] = useGlobalState<Settings>(globalSettings);

  return (
    <AppCard className={props?.cardClassName ?? ""}>
      <Card.Section withBorder inheritPadding py="xs">
        <Group justify="space-between">
          <Group className="flex flex-row justify-start items-center gap-2">
            <HiLocationMarker></HiLocationMarker>
            <Text fw={500}>Locations</Text>
          </Group>
          <Group className="flex flex-row justify-end items-center gap-2">
            <Button
              rightSection={<HiArrowRight />}
              variant="subtle"
              onClick={() => {
                navigate("/map");
              }}
            >
              {isMobile ? "Map" : "View in Map"}
            </Button>
          </Group>
        </Group>
      </Card.Section>

      <Card.Section mx="0" my="0" h={"100%"} className="h-full overflow-auto">
        {settings.home_globeCard_type == "animated" ? (
          <GlobeLocationsShowcase></GlobeLocationsShowcase>
        ) : (
          <Globe interactive={true}></Globe>
        )}
      </Card.Section>
    </AppCard>
  );
}
